import React from 'react'
import PropTypes from 'prop-types'
import ICONS from '../../stubs/ICONS'

const styles = {
  display: 'inline-block',
  verticalAlign: 'middle'
}

class Icon extends React.Component {
  render() {
    const icon = ICONS[this.props.icon]
    if (!icon) return null

    const { size, color } = this.props

    return (
      <span>
        <svg style={styles} width={`${size}px`} height={`${size}px`} viewBox={`0 0 ${icon.w} ${icon.h}`}>
          <g fill={color} fillRule={'evenodd'}><path d={icon.d}/></g>
        </svg>
        {this.props.child}
      </span>

    )
  }
}

Icon.propTypes = {
  icon:   PropTypes.string,
  size:   PropTypes.number,
  color:  PropTypes.string,
}

Icon.defaultProps = {
  size:   16,
  color:  'darkgray'
}

export default Icon



// WEBPACK FOOTER //
// ./src/components/widgets/Icon.js